export default __webpack_public_path__ + "static/media/logo.d20a015c.png";